export default __webpack_public_path__ + "locales/bg/JavascriptSdk.json?hash=a83a52529b435363d3c15ec3106d3a86";